import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { Divider } from '@mui/material';
import toast from 'react-hot-toast';
import { apiSendVerificationEmail } from '../../api/quoteApi';
import { JoveLogo } from '../Icons/Icons';
import { LoadingMask } from '../Loading/LoadingMask';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EmailUnregisteredComponent = function EmailUnregisteredComponent(props) {
  var email = props.email,
      loginIn = props.loginIn;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    if (email) {
      requestSendEmail(false);
    }
  }, [email]);
  /**
   * requests
   */

  var requestSendEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var showAlertMessage,
          params,
          _yield$apiSendVerific,
          _yield$apiSendVerific2,
          res,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              showAlertMessage = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              params = {
                email: email,
                hideErrToast: true
              };
              setLoading(true);
              _context.next = 5;
              return apiSendVerificationEmail(params);

            case 5:
              _yield$apiSendVerific = _context.sent;
              _yield$apiSendVerific2 = _slicedToArray(_yield$apiSendVerific, 1);
              res = _yield$apiSendVerific2[0];
              setLoading(false);

              if (res) {
                if (toast.success && showAlertMessage) toast.success('Send successfully！');
              } else {
                if (toast.error && showAlertMessage) toast.error('Send failure！');
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestSendEmail() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs("div", {
    className: "flex h-full flex-col items-center justify-center bg-[#EBEFFE]",
    children: [loading && /*#__PURE__*/_jsx(LoadingMask, {}), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row items-center space-x-20",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx(JoveLogo, {
          className: "absolute h-20 w-auto"
        }), /*#__PURE__*/_jsx("img", {
          src: "https://storage.googleapis.com/jove-public-images/website/landing-pages/universal/auth-email-unregistered-people.png",
          className: "h-auto w-[600px]"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "max-w-[640px] items-center rounded-xl bg-white px-10 py-14",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-[42px] font-black text-[#202020]",
          children: "Verify your email address"
        }), /*#__PURE__*/_jsxs("div", {
          className: "mt-14 flex flex-col space-y-7",
          children: [/*#__PURE__*/_jsxs("p", {
            className: "text-base font-medium text-[#202020]",
            children: ["You are almost done! A verification message has been sent to ", /*#__PURE__*/_jsx("span", {
              className: "font-bold",
              children: email
            }), "."]
          }), /*#__PURE__*/_jsx("p", {
            className: "text-base font-medium text-[#202020]",
            children: "Check your email and follow the link to finish creating your Jove account."
          }), /*#__PURE__*/_jsx(Divider, {
            className: "text-[#202020]"
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex flex-row items-center space-x-2",
              children: [/*#__PURE__*/_jsx("span", {
                className: "text-base font-bold",
                children: "Can't find the email? "
              }), /*#__PURE__*/_jsx("button", {
                className: "font-bold text-[#0E35D1]",
                onClick: function onClick() {
                  return requestSendEmail(true);
                },
                children: "Resend verification email"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-row items-center space-x-2",
              children: [/*#__PURE__*/_jsx("span", {
                className: "text-base font-bold",
                children: "I have verified the email address. "
              }), /*#__PURE__*/_jsx("button", {
                className: "font-bold text-[#0E35D1]",
                onClick: loginIn,
                children: "Login in"
              })]
            })]
          })]
        })]
      })]
    })]
  });
};